<div class="flex items-start gap-4 rounded-lg border border-cp-primary-100 p-6">
  <mat-icon svgIcon="cp-info" class="!size-6 shrink-0 text-cp-primary-100" />
  <p class="m-0 flex-1 text-base leading-6 text-cp-primary-100">{{ message() }}</p>
  @if (linkText() && linkHref()) {
    <a
      [href]="linkHref()"
      target="_blank"
      rel="noopener"
      class="shrink-0 whitespace-nowrap font-semibold text-cp-primary-100 underline"
    >
      {{ linkText() }}
    </a>
  }
</div>
